import _merge from "lodash/merge";
import * as keyboardKey from 'keyboard-key';
import menuButtonBehavior from '../MenuButton/menuButtonBehavior';
/**
 * @specification
 * Adds attribute 'tabIndex=-1' to 'toggleButton' slot.
 * Adds attribute 'aria-haspopup=true' to 'toggleButton' slot.
 */

var splitButtonBehavior = function splitButtonBehavior(props) {
  var splitButtonMenuButtonBehavior = function splitButtonMenuButtonBehavior(props) {
    var menuButtonBehaviorData = menuButtonBehavior(props);
    return _merge(menuButtonBehaviorData, {
      keyActions: {
        trigger: {
          open: {
            keyCombinations: [{
              keyCode: keyboardKey.ArrowDown,
              altKey: true
            }]
          }
        },
        popup: {
          closeAndFocusTrigger: {
            keyCombinations: [{
              keyCode: keyboardKey.Escape
            }, {
              keyCode: keyboardKey.ArrowUp,
              altKey: true
            }]
          }
        }
      }
    });
  };

  return {
    attributes: {
      root: {},
      toggleButton: {
        tabIndex: -1,
        'aria-haspopup': true
      }
    },
    childBehaviors: {
      menuButton: splitButtonMenuButtonBehavior
    }
  };
};

export default splitButtonBehavior;